interface IdleDeadline {
  didTimeout: boolean
  timeRemaining: () => number
}

interface IdleRequestOptions {
  timeout?: number
}

type IdleRequestCallback = (deadline: IdleDeadline) => void
type RequestIdleCallbackHandle = number

const DEFAULT_IDLE_TIMEOUT = 50
const DEFAULT_TIME_REMAINING = 50

class RequestIdleCallbackHelper {
  private static isPolyfillInitialized = false

  static setup() {
    if (this.isPolyfillInitialized) return

    if (typeof window === 'undefined') return

    if (typeof window.requestIdleCallback === 'undefined') {
      const createDeadline = (didTimeout: boolean): IdleDeadline => ({
        didTimeout,
        timeRemaining: () => (didTimeout ? 0 : DEFAULT_TIME_REMAINING)
      })

      const requestIdleCallback = (
        callback: IdleRequestCallback,
        options?: IdleRequestOptions
      ): RequestIdleCallbackHandle => {
        const timeoutValue = options?.timeout || DEFAULT_IDLE_TIMEOUT
        const handle = setTimeout(() => {
          const deadline = createDeadline(false)
          callback(deadline)
        }, timeoutValue)

        return Number(handle)
      }

      const cancelIdleCallback = (id: RequestIdleCallbackHandle): void => {
        clearTimeout(id)
      }

      window.requestIdleCallback = requestIdleCallback
      window.cancelIdleCallback = cancelIdleCallback

      this.isPolyfillInitialized = true
    }
  }

  static reset() {
    this.isPolyfillInitialized = false
  }
}

export default RequestIdleCallbackHelper
